import React from "react";
import PrescCard from "./PrescCard";

function Prescriptions(props) {
  let myPrescMarkup = props.prescriptions ? (
    props.prescriptions.map((presc, i )=> (
      <PrescCard presc={presc} key={i}></PrescCard>
    ))
  ) : (
    <p>loading</p>
  );

  return <div>{myPrescMarkup}</div>;
}

export default Prescriptions;
